import React from "react";

export default function CloseIcon({ onClick, className }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none" className={className} onClick={onClick}>
      <mask id="mask0_8878_1914" style={{ maskType: "alpha" }} maskUnits="userSpaceOnUse" x="4" y="4" width="16" height="16">
        <path d="M12.7071 12L19.7175 4.98958L19.0104 4.28247L12 11.2929L4.98958 4.28247L4.28247 4.98958L11.2929 12L4.28247 19.0104L4.98958 19.7175L12 12.7071L19.0104 19.7175L19.7175 19.0104L12.7071 12Z" fill="black" />
      </mask>
      <g mask="url(#mask0_8878_1914)">
        <rect y="0.5" width="24" height="24" fill="black" />
      </g>
    </svg>
  )
}